import i18n from '../../language/index'
import {create_title} from '@/base/titleData'

export default {
  animateCombObj: {
    value: 0,
    animate: {
      _key: 'none'
    }
  },
  animateType: 'module_animation',
  pc_infor: {
    marginTop: '0',
    marginRight: '0',
    marginBottom: '0',
    marginLeft: '0'
  },
  mb_infor: {
    marginTop: '0',
    marginRight: '0',
    marginBottom: '0',
    marginLeft: '0'
  },
  pc_widgets_infor: {
    size: {
      radio_val: 'default',
      default: {
        height: '27.7778%'
      },
      custom: {
        height: '27.7778%'
      }
    },
    title: create_title('Online map')
  },
  mb_widgets_infor: {
    title: create_title('Online map')
  },
  listArr: {
    city: i18n.t('widgets_basic_map_style_2596'),
    address: i18n.t('widgets_basic_map_style_2597'),
    addressInfo: '-',
    mapPoint: null
  }
}



// WEBPACK FOOTER //
// ./src/widgets/basic_map/style.js